import { Box, Tooltip, Typography } from "@mui/material"

export const getMetricEnterprises = (enterprises, kind, metricId, metric) => enterprises.filter(enterprise => {
    const state = enterprise[kind]?.[metricId] || {}
    const value = typeof metric === "function" ? metric(state) : state[metric]
    return typeof value === "number" ? value > 0 : Boolean(value)
})

const EnterpriseMetricTooltip = ({ enterprises = [], children, title = "Empresas", emptyText = "Nenhuma empresa neste indicador.", getValue }) => (
    <Tooltip arrow describeChild disableInteractive={false} componentsProps={{ tooltip: { sx: { maxWidth: 420 } } }} title={
        <Box sx={{ maxHeight: 280, overflowY: "auto", pr: 1 }}>
            <Typography variant="caption" component="div" sx={{ fontWeight: 700, mb: 0.5 }}>{title} ({enterprises.length})</Typography>
            {enterprises.length ? [...enterprises].sort((a, b) => a.name.localeCompare(b.name, "pt-BR")).map(enterprise => {
                const value = getValue?.(enterprise)
                return <Typography key={enterprise.id} variant="caption" component="div" sx={{ overflowWrap: "anywhere" }}>
                    {enterprise.name}{enterprise.accountcode ? ` · ${enterprise.accountcode}` : ""}{value != null && value !== "" ? ` — ${value}` : ""}
                </Typography>
            }) : <Typography variant="caption" component="div">{emptyText}</Typography>}
        </Box>
    }>
        <Box component="span" tabIndex={0} sx={{ cursor: "help" }}>{children}</Box>
    </Tooltip>
)

export const EnterpriseAdoptionTooltip = ({ enterprises = [], kind, metricId, children }) => {
    const enabled = getMetricEnterprises(enterprises, kind, metricId, "enabled")
    const used = getMetricEnterprises(enabled, kind, metricId, "used")
    return <EnterpriseMetricTooltip enterprises={enabled} title={`${used.length} de ${enabled.length} empresas habilitadas com uso`}
        getValue={enterprise => enterprise[kind][metricId].used ? "Com uso" : "Sem uso"}>
        {children}
    </EnterpriseMetricTooltip>
}

export default EnterpriseMetricTooltip
